export default {
  path: 'toasts',
  name: 'Toasts',
  childRoutes: [
  ],
};
